import { PERMISSIONS } from "../../constants";

export const ARCHIVER_CANCEL_DISABLED = "La anulación por el rol Archivo está desactivada en la configuración.";
export const FILED_CONFIG_UNAVAILABLE = "No se pudo cargar la configuración de radicados. Recarga la página.";

// Whether to offer Anular, as { visible, allowed, reason }. Mirrors
// cancelPermissionRefusal in gfunctions/handleCorrespondence, which decides for
// real:
//   - ADMIN always;
//   - an ARCHIVER only while config/filed.archiverCanCancel is on — shown
//     disabled with the reason when off, since the role is why they expect it;
//   - anyone else holding filed.cancel.
// `filedConfig` is undefined while loading and null when it failed to load; an
// archiver waits for it (disabled, no reason yet) or is told it failed.
export const canCancelFiled = (user, filedConfig) => {
  const none = { visible: false, allowed: false, reason: null };
  if (!user) return none;
  const roles = Array.isArray(user.roles) ? user.roles : [];
  const permissions = Array.isArray(user.permissions) ? user.permissions : [];

  if (roles.includes("ADMIN")) return { visible: true, allowed: true, reason: null };
  if (roles.includes("ARCHIVER")) {
    if (filedConfig === undefined) return { visible: true, allowed: false, reason: null };
    if (filedConfig === null) return { visible: true, allowed: false, reason: FILED_CONFIG_UNAVAILABLE };
    return filedConfig.archiverCanCancel === false
      ? { visible: true, allowed: false, reason: ARCHIVER_CANCEL_DISABLED }
      : { visible: true, allowed: true, reason: null };
  }
  return permissions.includes(PERMISSIONS.FILED.CANCEL)
    ? { visible: true, allowed: true, reason: null }
    : none;
};
